(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "prop-types", "react", "./formField"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("prop-types"), require("react"), require("./formField"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.propTypes, global.react, global.formField);
    global.SmartInputField = mod.exports;
  }
})(this, function (_exports, _propTypes, _react, _formField) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports["default"] = _exports.SmartInputFieldRaw = void 0;
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireDefault(_react);
  _formField = _interopRequireDefault(_formField);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

  function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

  function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function stopPropagation(event) {
    event.stopPropagation();
  }
  /**
   * Renders a smart input that allows to choose zero or more values (for example a tag list).
   * Values can be deduced from the entered text. Additionally this input allows autocompletion by
   * a user defined suggestion function.
   */


  var SmartInputFieldRaw =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(SmartInputFieldRaw, _React$Component);

    function SmartInputFieldRaw() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, SmartInputFieldRaw);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(SmartInputFieldRaw)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "state", {
        text: '',
        focused: false,
        loading: false,
        suggestions: null,
        activeSuggestionIndex: null
      });

      _defineProperty(_assertThisInitialized(_this), "suggestionsNodeRef", _react["default"].createRef());

      _defineProperty(_assertThisInitialized(_this), "suggestionNodeRefs", {});

      _defineProperty(_assertThisInitialized(_this), "focus", function () {
        if (_this.input) {
          _this.input.focus();
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
        var text = event.target.value; // update current entered text in state and update suggestion list

        _this.setState({
          text: text
        });

        _this.getSuggestions(text, _this.props.value);
      });

      _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
        var _this$props = _this.props,
            value = _this$props.value,
            onChange = _this$props.onChange,
            convertTextToValue = _this$props.convertTextToValue,
            convertSuggestionToValue = _this$props.convertSuggestionToValue,
            strict = _this$props.strict,
            hideValues = _this$props.hideValues,
            resetText = _this$props.resetText,
            selectText = _this$props.selectText;
        var _this$state = _this.state,
            text = _this$state.text,
            suggestions = _this$state.suggestions,
            activeSuggestionIndex = _this$state.activeSuggestionIndex;

        switch (event.keyCode) {
          // enter
          case 13:
            {
              // a suggestion must be selected or some text must have been entered
              if (typeof activeSuggestionIndex === 'number' || event.target.value) {
                event.preventDefault();
                var nextValue = typeof activeSuggestionIndex === 'number' // use value from suggestion
                ? convertSuggestionToValue(suggestions[activeSuggestionIndex]) // use value from entered text (if non-strict)
                : !strict ? convertTextToValue(event.target.value.trim()) : null;

                if (nextValue) {
                  // update value and reset entered text and suggestion list
                  var newValue = value.concat([nextValue]);
                  onChange(newValue);

                  if (resetText) {
                    _this.resetText();

                    _this.getSuggestions('', newValue);
                  } else {
                    _this.getSuggestions(_this.state.text, newValue);

                    selectText && _this.input.select();
                  }
                }
              }

              break;
            }
          // escape

          case 27:
            {
              event.preventDefault();

              _this.resetText();

              break;
            }
          // backspace

          case 8:
            {
              // if text is empty, then drop the last value from the list
              if (!hideValues && text.length === 0 && value.count() > 0) {
                var _newValue = value.slice(0, value.count() - 1);

                onChange(_newValue);

                _this.resetText();

                _this.getSuggestions('', _newValue);
              }

              break;
            }
          // up

          case 38:
            {
              if (suggestions) {
                event.preventDefault();

                _this.selectPreviousSuggestion();
              }

              break;
            }
          // down

          case 40:
            {
              if (suggestions) {
                event.preventDefault();

                _this.selectNextSuggestion();
              }

              break;
            }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
        var value = _this.props.value;
        var text = _this.state.text;

        _this.setState({
          focused: true
        });

        _this.getSuggestions(text, value);
      });

      _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
        var onBlur = _this.props.onBlur;

        _this.setState({
          focused: false
        });

        _this.resetText();

        onBlur();
      });

      _defineProperty(_assertThisInitialized(_this), "handleMouseDownContainer", function (event) {
        event.preventDefault(); // input is visually the whole container, even though the actual HTML input is not spanning the whole container,
        // so we trigger focusing the input here

        _this.input && _this.input.focus();
      });

      _defineProperty(_assertThisInitialized(_this), "handleClickValueRemove", function (index) {
        var _this$props2 = _this.props,
            value = _this$props2.value,
            onChange = _this$props2.onChange;
        return function (event) {
          event.preventDefault();
          var newValue = value.slice(0, index).concat(value.slice(index + 1));
          onChange(newValue);
        };
      });

      _defineProperty(_assertThisInitialized(_this), "handleClickSuggestion", function (suggestion, index) {
        var self = _assertThisInitialized(_this);

        var _this$props3 = _this.props,
            value = _this$props3.value,
            onChange = _this$props3.onChange,
            suggestionDisabled = _this$props3.suggestionDisabled,
            convertSuggestionToValue = _this$props3.convertSuggestionToValue,
            resetText = _this$props3.resetText,
            selectText = _this$props3.selectText;
        return function () {
          if (!suggestionDisabled(suggestion, index)) {
            var newValue = value.concat([convertSuggestionToValue(suggestion)]);
            onChange(newValue);

            if (resetText) {
              self.resetText();
              self.getSuggestions('', newValue);
            } else {
              self.getSuggestions(self.state.text, newValue);
              selectText && self.input.select();
            }
          }
        };
      });

      _defineProperty(_assertThisInitialized(_this), "handleMouseEnterSuggestion", function (suggestion, index) {
        var self = _assertThisInitialized(_this);

        var suggestionDisabled = _this.props.suggestionDisabled;
        return function () {
          if (!suggestionDisabled(suggestion, index)) {
            self.selectSuggestion(index);
          }
        };
      });

      _defineProperty(_assertThisInitialized(_this), "resetText", function () {
        _this.setState({
          text: '',
          suggestions: null,
          activeSuggestionIndex: null
        });
      });

      _defineProperty(_assertThisInitialized(_this), "getSuggestions", function (text, value) {
        var _this$props4 = _this.props,
            getSuggestions = _this$props4.getSuggestions,
            suggestionDisabled = _this$props4.suggestionDisabled,
            strict = _this$props4.strict;

        if (getSuggestions) {
          _this.setState({
            loading: true
          });

          getSuggestions(text, value).then(function (suggestions) {
            _this.setState({
              suggestions: suggestions
            }); // if non-strict, then of all non-disabled suggestions pick the first and select it


            var selection = strict && suggestions && suggestions.map(function (suggestion, index) {
              return [suggestion, index];
            }).filter(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                  s = _ref2[0],
                  i = _ref2[1];

              return !suggestionDisabled(s, i);
            })[0];

            _this.selectSuggestion(selection ? selection[1] : null);
          })["catch"](function () {
            _this.setState({
              loading: false
            });
          });
        }
      });

      _defineProperty(_assertThisInitialized(_this), "selectPreviousSuggestion", function () {
        var _this$props5 = _this.props,
            suggestionDisabled = _this$props5.suggestionDisabled,
            strict = _this$props5.strict;
        var _this$state2 = _this.state,
            suggestions = _this$state2.suggestions,
            activeSuggestionIndex = _this$state2.activeSuggestionIndex;

        if (typeof activeSuggestionIndex === 'number') {
          // of all non-disabled suggestion pick the next after the current
          var selection = suggestions && suggestions.map(function (suggestion, index) {
            return [suggestion, index];
          }).filter(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                s = _ref4[0],
                i = _ref4[1];

            return i < activeSuggestionIndex && !suggestionDisabled(s, i);
          }).reverse()[0];

          if (selection) {
            _this.selectSuggestion(selection[1]);
          } else {
            if (!strict) {
              _this.selectSuggestion(null);
            }
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "selectNextSuggestion", function () {
        var suggestionDisabled = _this.props.suggestionDisabled;
        var _this$state3 = _this.state,
            suggestions = _this$state3.suggestions,
            activeSuggestionIndex = _this$state3.activeSuggestionIndex;

        if (typeof activeSuggestionIndex === 'number') {
          // of all non-disabled suggestion pick the next before the current
          var selection = suggestions && suggestions.map(function (suggestion, index) {
            return [suggestion, index];
          }).filter(function (_ref5) {
            var _ref6 = _slicedToArray(_ref5, 2),
                s = _ref6[0],
                i = _ref6[1];

            return i > activeSuggestionIndex && !suggestionDisabled(s, i);
          })[0];

          if (selection) {
            _this.selectSuggestion(selection[1]);
          }
        } else {
          var _selection = suggestions && suggestions.map(function (suggestion, index) {
            return [suggestion, index];
          }).filter(function (_ref7) {
            var _ref8 = _slicedToArray(_ref7, 2),
                s = _ref8[0],
                i = _ref8[1];

            return !suggestionDisabled(s, i);
          })[0];

          if (_selection) {
            _this.selectSuggestion(_selection[1]);
          }
        }
      });

      _defineProperty(_assertThisInitialized(_this), "selectSuggestion", function (index) {
        _this.setState({
          activeSuggestionIndex: index
        });

        var suggestionsNode = _this.suggestionsNodeRef.current;
        var suggestionNode = _this.suggestionNodeRefs[index];

        if (suggestionsNode && suggestionNode) {
          var r1 = suggestionsNode.getBoundingClientRect();
          var r2 = suggestionNode.getBoundingClientRect(); // check if there is the need for scrolling down

          if (r1.bottom - 1 < r2.bottom) suggestionsNode.scrollTop += r2.bottom - r1.bottom + 1; // check if there is the need for scrolling up

          if (r1.top + 1 > r2.top) suggestionsNode.scrollTop += r2.top - r1.top - 1;
        }
      });

      return _this;
    }

    _createClass(SmartInputFieldRaw, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props6 = this.props,
            value = _this$props6.value,
            suggestionDisabled = _this$props6.suggestionDisabled,
            autoFocus = _this$props6.autoFocus,
            renderValue = _this$props6.renderValue,
            renderSuggestion = _this$props6.renderSuggestion,
            hideValues = _this$props6.hideValues,
            placeholderText = _this$props6.placeholderText,
            className = _this$props6.className,
            disabled = _this$props6.disabled;
        var _this$state4 = this.state,
            text = _this$state4.text,
            focused = _this$state4.focused,
            suggestions = _this$state4.suggestions,
            activeSuggestionIndex = _this$state4.activeSuggestionIndex;
        var suggestionsVisible = suggestions && suggestions.length > 0;
        var styles = typeof className === 'string' ? {
          base: className,
          baseFocused: className + '-focused',
          baseWithSuggestions: className + '-with-suggestions',
          input: className + '-input',
          inputValue: className + '-input-value',
          inputText: className + '-input-text',
          suggestions: className + '-suggestions',
          suggestion: className + '-suggestion',
          suggestionActive: className + '-suggestion-active',
          suggestionDisabled: className + '-suggestion-disabled'
        } : this.props.className;

        var inputField = _react["default"].createElement("input", {
          type: "text",
          value: text,
          autoFocus: autoFocus,
          onChange: this.handleChange,
          onKeyDown: this.handleKeyDown,
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onMouseDown: stopPropagation,
          autoComplete: "off",
          autoCorrect: "off",
          autoCapitalize: "off",
          spellCheck: false,
          placeholder: placeholderText,
          className: styles.inputText,
          key: "inputField",
          ref: function ref(node) {
            _this2.input = node;
          },
          disabled: disabled
        });

        var values = hideValues ? [] : value.map(function (value, index) {
          return _react["default"].createElement("div", {
            key: index,
            onMouseDown: stopPropagation,
            className: styles.inputValue
          }, renderValue(value, _this2.handleClickValueRemove(index)));
        });
        return _react["default"].createElement("div", {
          className: [styles.base, focused && styles.baseFocused, suggestionsVisible && styles.baseWithSuggestions].filter(Boolean).join(' '),
          onMouseDown: this.handleMouseDownContainer
        }, _react["default"].createElement("div", {
          className: styles.input
        }, values.concat(inputField)), suggestionsVisible && _react["default"].createElement("div", {
          className: styles.suggestions,
          ref: this.suggestionsNodeRef
        }, suggestions.map(function (suggestion, index) {
          return _react["default"].createElement("div", {
            key: index,
            onClick: _this2.handleClickSuggestion(suggestion, index),
            onMouseEnter: _this2.handleMouseEnterSuggestion(suggestion, index),
            className: [styles.suggestion, activeSuggestionIndex === index && styles.suggestionActive, suggestionDisabled(suggestion, index) && styles.suggestionDisabled].filter(Boolean).join(' '),
            ref: function ref(node) {
              _this2.suggestionNodeRefs[index] = node;
            }
          }, renderSuggestion(suggestion));
        })));
      }
    }]);

    return SmartInputFieldRaw;
  }(_react["default"].Component);

  _exports.SmartInputFieldRaw = SmartInputFieldRaw;

  _defineProperty(SmartInputFieldRaw, "propTypes", {
    // current value
    value: _propTypes["default"].any.isRequired,
    // disable input
    disabled: _propTypes["default"].bool,
    // should the input text be reset after each selection (default: true)
    resetText: _propTypes["default"].bool,
    // should the input text be selected after each selection (only if 'resetText' is false, default: true)
    selectText: _propTypes["default"].bool,
    // value change handler
    onChange: _propTypes["default"].func.isRequired,
    // blur handler
    onBlur: _propTypes["default"].func,
    // function to generate suggestion list (must return a promise)
    getSuggestions: _propTypes["default"].func,
    // decision function, whether a given suggestion can be choosen
    suggestionDisabled: _propTypes["default"].func,
    // if non-strict, this function deduces the actual value to add from the entered text
    convertTextToValue: _propTypes["default"].func,
    // this function converts the suggestion to the actual value to add
    convertSuggestionToValue: _propTypes["default"].func,
    // whether one can enter anything or just stuff from the suggestion list
    strict: _propTypes["default"].bool,
    // autoFocus of the underlying HTML input
    autoFocus: _propTypes["default"].bool,
    // how to render a value
    renderValue: _propTypes["default"].func,
    // how to render a suggestion
    renderSuggestion: _propTypes["default"].func,
    // whether to hide the already selected values
    hideValues: _propTypes["default"].bool,
    // the text which is displayed within the input field before anything is typed in
    placeholderText: _propTypes["default"].string,
    className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({
      base: _propTypes["default"].string.isRequired,
      baseFocused: _propTypes["default"].string.isRequired,
      baseWithSuggestions: _propTypes["default"].string.isRequired,
      input: _propTypes["default"].string.isRequired,
      inputValue: _propTypes["default"].string.isRequired,
      inputText: _propTypes["default"].string.isRequired,
      suggestions: _propTypes["default"].string.isRequired,
      suggestion: _propTypes["default"].string.isRequired,
      suggestionActive: _propTypes["default"].string.isRequired,
      suggestionDisabled: _propTypes["default"].string.isRequired
    })]).isRequired
  });

  _defineProperty(SmartInputFieldRaw, "defaultProps", {
    suggestionDisabled: function suggestionDisabled(suggestion, index) {
      return false;
    },
    convertTextToValue: function convertTextToValue(text) {
      return text;
    },
    convertSuggestionToValue: function convertSuggestionToValue(suggestion) {
      return suggestion;
    },
    renderValue: function renderValue(value, handleRemove) {
      return _react["default"].createElement("div", null, _react["default"].createElement("div", {
        onClick: handleRemove
      }, "X"), value.toString());
    },
    renderSuggestion: function renderSuggestion(suggestion) {
      return suggestion.toString();
    },
    strict: false,
    autoFocus: false,
    hideValues: false,
    onBlur: function onBlur() {},
    disabled: false,
    resetText: true,
    selectText: true
  });

  var _default = (0, _formField["default"])()(SmartInputFieldRaw);

  _exports["default"] = _default;
});